const COMPANY_MISMATCH_PATTERN = /does not belong to your company/i

const COMPANY_MISMATCH_HINT =
  'Your active company may have changed, please refresh the page and try again.'

export const buildMutationErrorMessage = (
  error: { graphQLErrors?: { message?: string }[] } | undefined,
  fallback: string
) => {
  const message = error?.graphQLErrors?.[0]?.message
  if (message && COMPANY_MISMATCH_PATTERN.test(message)) {
    return `${message}. ${COMPANY_MISMATCH_HINT}`
  }
  return fallback
}
